import React, { useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { ApproveAgreement, UPDATE_FORM_BUILDER_BY_FORM_STRING_ID } from '../../../graphql/mutation'
import { toast } from 'react-toastify'
import { GET_ALL_FORM_BUILDER_BY_BG_ACCOUNT_ID, GET_FRANCHISE } from '../../../graphql/query'
import { useParams } from 'react-router-dom'
import { error } from 'console'

interface Props {
  closeApproveModal: () => void
  franchiseId: any
}

const ApproveAgreementModal: React.FC<Props> = ({ closeApproveModal, franchiseId }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const { data, loading, error } = useQuery(GET_FRANCHISE, {
    variables: {
      input: {
        franchiseId: franchiseId,
        offset: 0,
        limit: 10
      }
    }
  })

  const [approveAgreement] = useMutation(ApproveAgreement, {
    refetchQueries: [
      {
        query: GET_FRANCHISE,
        variables: {
          input: {
            franchiseId: franchiseId,
            offset: 0,
            limit: 10
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Agreement-Details'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'Agreement-Details'
      }
    }
  })

  const franchiseAgreement = data?.getFranchise?.franchiseAgreements[0]

  const handleApprove = async () => {
    try {
      setIsLoading(true)
      const result = await approveAgreement({
        variables: {
          input: {
            id: parseInt(franchiseAgreement?.id || '')
          }
        }
      })
      console.log(result)

      toast.success('Agreement approved successfully')
    } catch (error) {
      console.error('Error approving agreement:', error)
      toast.error('Failed to approve agreement')
    } finally {
      setIsLoading(false)
      closeApproveModal()
    }
  }

  if (loading) {
    return <p>Loading...</p>
  }

  if (error) {
    return <p>Error: {error.message}</p>
  }

  return (
    <div className='card-body'>
      <p className='fs-5 fw-bold'>Are you sure you want to Approve?</p>

      <div className='d-flex justify-content-end mt-10'>
        <button
          type='reset'
          className='btn btn-sm btn-white me-2'
          onClick={() => closeApproveModal()}
        >
          Cancel
        </button>

        <button type='submit' className='btn btn-sm btn-primary' onClick={handleApprove}>
          <span className='indicator-label'>Save</span>
        </button>
      </div>
    </div>
  )
}

export default ApproveAgreementModal
